/* Inches / cm toggle for the size charts (popup and Size Charts page). Remembers the choice per browser. */
(function () {
  if (window.__lmSizeChartUnits) return;
  window.__lmSizeChartUnits = true;
  var KEY = 'lm-size-chart-units';
  function apply(root, units) {
    root.setAttribute('data-units', units);
    root.querySelectorAll('.lm-sc-units button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-units') === units ? 'true' : 'false');
    });
  }
  function saved() {
    try { return localStorage.getItem(KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }
  function init() {
    var units = saved();
    document.querySelectorAll('.lm-sc').forEach(function (root) { apply(root, units); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lm-sc-units button');
    if (btn) {
      var units = btn.getAttribute('data-units');
      apply(btn.closest('.lm-sc'), units);
      try { localStorage.setItem(KEY, units); } catch (err) {}
      return;
    }
    if (e.target.closest('[id^="SizeChartOpen-"]')) init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
